import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { unwrapV2, V2ApiResponse } from '../../../shared/utils/v2-api-response.util';
import { SearchPayload } from '../../../shared/utils/table-types';
import { InvestmentListResult, requestInvestmentList } from '../../shared/investment-list.util';
import { InvestmentService } from '../../../../modules/investment/investment.service';
import {
  InvestmentAssetAmortizationLine,
  InvestmentAssetCoefficient,
  InvestmentAssetDeposit,
  InvestmentAssetDetail,
  InvestmentAssetKind,
  InvestmentAssetListSummary,
  InvestmentAssetRecord,
  InvestmentAssetRow,
} from '../models/investment-asset.model';

export type InvestmentAssetListResult = InvestmentListResult<InvestmentAssetRow, InvestmentAssetListSummary>;

@Injectable({ providedIn: 'root' })
export class InvestmentAssetReadService {

  constructor(private http: HttpClient, private investmentService: InvestmentService) { }

  list(kind: InvestmentAssetKind, payload: SearchPayload): Promise<InvestmentAssetListResult> {
    return requestInvestmentList<InvestmentAssetRow, InvestmentAssetListSummary>(this.http, kind.listEndpoint + '/list', payload, 'No se pudo cargar la lista de inversiones');
  }

  detail(uid: string): Promise<InvestmentAssetDetail> {
    return unwrapV2(
      firstValueFrom(this.http.get<V2ApiResponse<InvestmentAssetDetail>>(`${environment.apiUrl}/api/v2/investment-assets/${uid}/detail`)),
      'No se pudieron cargar las operaciones de la inversión'
    );
  }

  get(uid: string): Promise<InvestmentAssetRecord> {
    return this.investmentService.loadData(uid) as unknown as Promise<InvestmentAssetRecord>;
  }

  deposits(uid: string): Promise<InvestmentAssetDeposit[]> {
    return this.investmentService.investmentDepositList(uid) as unknown as Promise<InvestmentAssetDeposit[]>;
  }

  amortization(uid: string): Promise<InvestmentAssetAmortizationLine[]> {
    return this.investmentService.GetAmortisation(uid) as unknown as Promise<InvestmentAssetAmortizationLine[]>;
  }

  coefficient(accountNumber: string): Promise<InvestmentAssetCoefficient> {
    return this.investmentService.investmentAmortizationTable(accountNumber);
  }
}
